import { inject } from "@angular/core";
import { Store } from "@ngxs/store";
import { GetOnboarding } from "src/app/store/onboarding/onboarding.action";

export function OnboardingResolver() {
    return inject(Store).dispatch(new GetOnboarding());
}